// extracted by mini-css-extract-plugin
export default {"icon":"UserMenu_icon__w6vkE","title":"UserMenu_title__A+D4w","menuItem":"UserMenu_menuItem__XAjQP","menu":"UserMenu_menu__dr0h0","button":"UserMenu_button__By9wk"};